import { render, staticRenderFns } from "./KTitle.vue?vue&type=template&id=c2746730&lang=pug"
import script from "./KTitle.vue?vue&type=script&lang=js"
export * from "./KTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports